import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AttendeeRow } from '../attendance.dialog';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, accAreaAService: AcceleratorAreaService, accSessionId?: number): GridSetup<AttendeeRow> {

	return {
		rowName: { singular: 'Entrepreneur', plural: 'Entrepreneurs' },
		getRowKey: row => '' + row.accEntrepreneurId,
		stateKey: 'accelerator-sessions-attendance-grid',
		actions: getActions(dialogService, accAreaAService, accSessionId),
		buttons: [],
		columns: getColumns(util),
		multiselect: true,
	}
}
